export const versions = {
  version: "1.0.183",
  revision: "8d22a5262",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5030-g8d22a5262-dirty",
    hash: "g8d22a5262",
    distance: 5030,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5030-g8d22a5262-dirty",
    semverString: "1.0.183+5030.g8d22a5262.dirty"
  }
};
